import "./ProgressBar.scss";

const ProgressBar: React.FC<{
  progress: number;
  className?: string;
}> = ({ progress, className }) => {
  const width = Math.min(progress, 100);
  const classes = ["progress-bar", className].filter(c => !!c).join(" ");
  return (
    <div className={classes}>
      <div
        className="complete"
        data-testid="progress-bar-complete"
        style={{ width: `${width}%` }}
      />
    </div>
  );
};

export default ProgressBar;
